module.exports = __webpack_public_path__ + "static/media/IMG_4158.8ed79e54.JPG";